import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import axios from 'axios'
import i18n from './lang'
Vue.prototype.$bus = new Vue()
import publicVariable from './utils/global.js'
Vue.prototype.GLOBAL = publicVariable

import VueDragResize from 'vue-drag-resize'
Vue.component('vue-drag-resize', VueDragResize);

import buttonReset from '@/components/ButtonSearch/buttonReset.vue'
Vue.component('buttonReset', buttonReset);

import buttonSearch from '@/components/ButtonSearch/buttonSearch.vue'
Vue.component('buttonSearch', buttonSearch);

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log


import * as filters from './filters' // global filters

// my compontent

import titleBorder from './components/EpcTitle/titleBorder.vue'
import subnav from './components/EpcTitle/subnav.vue'

Vue.component('titleBorder', titleBorder)
Vue.component('subnav', subnav)


Vue.prototype.$axios = axios
// axios优化2: 配置基础地址, 只要配置了基础地址, 将来axios的请求都会自动拼上这个基准路径
// axios.defaults.baseURL = 'https://tis-cos-dev-new-1256914302.cos.ap-shanghai.myqcloud.com'




/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//
// }

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})
